import apiClient from './api.client'

export interface DeckCard {
  cardId: string
  quantity: number
}

export interface Deck {
  id: string
  name: string
  description?: string
  format: string
  isPublic: boolean
  userId: string
  cards?: DeckCard[]
  createdAt: string
  updatedAt: string
}

export interface CreateDeckRequest {
  name: string
  description?: string
  format?: string
  isPublic?: boolean
  cards?: DeckCard[]
}

export const decksService = {
  async getDecks(): Promise<Deck[]> {
    const response = await apiClient.instance.get<{ success: boolean; data: Deck[] }>('/api/decks')
    return response.data.data
  },

  async getDeck(id: string): Promise<Deck | null> {
    const response = await apiClient.instance.get<{ success: boolean; data: Deck }>(`/api/decks/${id}`)
    return response.data.success ? response.data.data : null
  },

  async getDeckWithCards(id: string): Promise<Deck | null> {
    const response = await apiClient.instance.get<{ success: boolean; data: Deck }>(`/api/decks/${id}/cards`)
    return response.data.success ? response.data.data : null
  },

  async createDeck(deck: CreateDeckRequest): Promise<Deck> {
    const response = await apiClient.instance.post<{ success: boolean; data: Deck }>('/api/decks', deck)
    return response.data.data
  },

  async updateDeck(id: string, deck: Partial<CreateDeckRequest>): Promise<void> {
    await apiClient.instance.put(`/api/decks/${id}`, deck)
  },

  async deleteDeck(id: string): Promise<void> {
    await apiClient.instance.delete(`/api/decks/${id}`)
  },

  async addCard(deckId: string, cardId: string, quantity = 1): Promise<void> {
    await apiClient.instance.post(`/api/decks/${deckId}/cards`, { cardId, quantity })
  },

  async removeCard(deckId: string, cardId: string): Promise<void> {
    await apiClient.instance.delete(`/api/decks/${deckId}/cards/${cardId}`)
  },

  async exportDeck(id: string, format: string = 'text'): Promise<string> {
    const response = await apiClient.instance.get<{ success: boolean; data: string }>(`/api/decks/${id}/export?format=${format}`)
    return response.data.data
  },
}
